<template>
  <div class="Role">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <h4>Tìm kiếm</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
          <CCol sm="6">
            <CInput
              label="Quyền"
              placeholder="Điền thông tin để tìm kiếm"
              v-validate="'required'"
              v-model="valueRoleName"
              v-on:keyup.enter="searchTK()"
              class=" pt-1"
            />
          </CCol>
          <CCol sm="6" class="custom_btn">
            <vs-button
              warn
              square
              class="custom_btn_search float-left"
              @click="searchTK()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
            <vs-button square class="float-left" @click="addNewRoles()">
              <i class="bx bx-plus"></i>&nbsp;Thêm quyền</vs-button
            >
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
          perPage: 20,
        }"
        :line-numbers="true"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'status'" class="center">
            <CBadge v-if="props.row.status == 1" color="success"
              >Hoạt động</CBadge
            >
            <CBadge v-else color="warning">Không hoạt động</CBadge>
          </div>
          <div v-else-if="props.column.field === 'action'" class="row center">
            <div v-if="props.row.status == 1" class="center">
              <vs-tooltip color="square">
                <template #tooltip>
                  Sửa quyền
                </template>
                <vs-button
                  transparent
                  @click="goRoleDetal(props.row)"
                  circle
                  icon
                >
                  <i class="bx bx-calendar-edit"></i>
                </vs-button>
              </vs-tooltip>
              <vs-tooltip color="danger">
                <template #tooltip>
                  Khoá
                </template>
                <vs-button
                  transparent
                  @click="LockRoles(props.row)"
                  danger
                  circle
                  icon
                >
                  <i class="bx bx-lock-alt"></i
                ></vs-button>
              </vs-tooltip>
            </div>

            <div v-if="props.row.status == -1" class="center">
              <vs-tooltip color="success">
                <template #tooltip>
                  Mở khoá
                </template>
                <vs-button
                  transparent
                  @click="LockRoles(props.row)"
                  success
                  circle
                  icon
                >
                  <i class="bx bx-lock-open-alt"></i
                ></vs-button>
              </vs-tooltip>
            </div>
          </div>
        </template>
      </vue-good-table>
    </CCard>
    <vs-dialog prevent-close width="450px" v-model="state.dialog.lock">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
        <span class="center">Bạn có chắc chắn muốn thực hiện thao tác này không?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="SubmitLock()">
            Đồng ý
          </vs-button>
          <vs-button @click="state.dialog.lock = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog prevent-close width="550px" v-model="state.dialog.EditRole">
      <template #header>
        <h4 class="not-margin">
          Cập nhật quyền
        </h4>
      </template>

      <div class="con-form">
        <CRow class="mb-2">
          <CCol sm="12" class="mb-2">
            <CInput
              label="Tên quyền (*)"
              placeholder=""
              v-validate="'required'"
              v-model="edit_role_name"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="SubmitEditRole">
            Cập nhật
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog
      prevent-close
      class="employee-dialog"
      width="800px"
      v-model="state.dialog.NewRolesDetail"
    >
      <template #header>
        <h4 class="not-margin">
          Thêm mới quyền
        </h4>
      </template>
      <div class="con-form">
        <CRow class="mb-2">
          <CCol sm="12" class="mb-2">
            <CInput
              label="Quyền (*)"
              placeholder=""
              v-validate="'required'"
              v-model="new_role_name"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="AddRolesSubmit">
            Thêm mới
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const usersApi = ClientFactory.get("users");
const rolegroupsApi = ClientFactory.get("rolegroups");
const dropdownsApi = ClientFactory.get("dropdowns");
const employeesApi = ClientFactory.get("employees");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    valueDepartment: "0",
    dataDepartment: [],
    valueRoleName: "",
    activeAddHoliday: false,
    add_day: "",
    add_note: "",

    columns: [
      {
        label: "Quyền ID",
        field: "id",
        hidden: true,
      },
      {
        label: "Tên quyền",
        field: "role_name",
        thClass: "text-center",
      },
      {
        label: "Trạng thái",
        field: "status",
        thClass: "text-center",
      },
      {
        label: "Thao tác",
        field: "action",
        thClass: "text-center",
        width: "200px",
      },
    ],
    rows: [
      {
        session: "<button>My Action</button>",
        // ...
      },
    ],

    dataTK: [],

    state: {
      dialog: {
        role: false,
        grouprole: false,
        EditRole: false,
        lock: false,
        NewRolesDetail: false,
      },
    },

    role_id: 0,
    lock_role: 0,

    new_role_name: "",
    dataEmployee: [],

    edit_role_name: "",
  }),
  async created() {
    this.searchTK();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        role_name: this.valueRoleName,
      };
      console.log(params);
      const result = await rolegroupsApi.list_role(params);

      this.checkResponseData(result);
    },

    async goRoleDetal(params) {
      this.role_id = params.id;
      this.edit_role_name = params.role_name;
      this.state.dialog.EditRole = true;
    },
    async SubmitEditRole() {
      this.loading(this.$vs);
      let body = {};
      body.role_id = this.role_id;
      body.role_name = this.edit_role_name;
      console.log(body);
      const result = await rolegroupsApi.update_role(body);

      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.EditRole = false;
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    //#region  new Roles
    async addNewRoles() {
      this.state.dialog.NewRolesDetail = true;
    },

    async AddRolesSubmit() {
      const body = {};
      body.role_name = this.new_role_name;
      const result = await rolegroupsApi.create_role(body);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.NewRolesDetail = false;
        this.ResetFormAdd();
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },

    async ResetFormAdd() {
      this.new_role_name = "";
    },

    //#endregion
    //#region  LOCK Roles

    async LockRoles(params) {
      this.role_id = params.id;
      this.lock_role = params.status === 1 ? 1 : 0;
      this.state.dialog.lock = true;
    },

    async SubmitLock() {
      this.loading(this.$vs);
      let body = {};
      body.role_id = this.role_id;
      body.lock = this.lock_role;
      console.log(body);
      const result = await rolegroupsApi.lock_role(body);

      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.lock = false;
        this.add_note = "";
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    //#endregion
    checkResponseData: function(data) {
      console.log(data);
      if (data.status == "success") {
        this.dataTK = data.data;
      } else {
        this.dataTK = [];
      }
      this.closeLoading();
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
};
</script>

<style lang="scss">
.Role {
  .custom_btn {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .con-form .vs-select-content {
    max-width: 500px;
  }
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .tk-width-class {
    min-width: 10px !important;
    text-align: center;
  }
  .tk-name-class {
    min-width: none;
    -width: 250px !important;
  }

  .tk-month-class {
    min-width: none;
    -width: 80px !important;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .tk-status-class {
    min-width: 100px;
    text-align: center;
  }
  .tk-action-class {
    min-width: 150px;
    text-align: center;
  }
  .nv_select {
    max-width: 500px;
  }
}
</style>
